import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.545 9L8.25 8.295L5.96 6L8.25 3.705L7.545 3L4.545 6L7.545 9Z", fill: "black" }));
export default SvgArrowLeft;
